<template>
    <div>
        <Drawer :title="$t('配置用户')"
                v-model="show"
                width="980"
                :mask-closable="false"
                :styles="styles">
            <rcTable ref="rcTable"
                     v-if="show"
                     :tableAttr="tableAttr">
                <Button slot="tootipL"
                        @click="refresh">
                    <i class="icon-refresh-o-2"></i>
                </Button>
                <Button type="primary"
                        slot="tootipL"
                        @click="configClick()">
                    <i class="icon-plus-o-1"></i>{{$t('配置用户')}}
                </Button>
            </rcTable>
        </Drawer>
        <!--配置-->
        <configureusers ref="configureusers"
                        @refresh="refresh"></configureusers>
    </div>
</template>
<script>
import API from '@/service/api'
import rcTable from '@/views/components/basic/rcTable'
import configureusers from './configureusers'
export default {
    name: 'projectset',
    components: {
        rcTable,
        configureusers
    },
    data () {
        return {
            show: false,
            data: [],
            styles: {
                height: 'calc(100% - 55px)',
                overflow: 'auto',
                paddingBottom: '53px',
                position: 'static'
            },
            statusList: Object.freeze({
                0: this.$t('禁用'),
                1: this.$t('启用'),
                2: this.$t('待审核'),
                4: this.$t('拒绝'),
                9: this.$t('锁定')
            }),
            tableAttr: {
                source: {
                    type: 'get',
                    url: '',
                    params: {}
                },
                isMultiSelect: false,
                searchShow: true,
                columnsChooseShow: true,
                searchColumns: [
                    {
                        key: 'accountLike',
                        title: this.$i18n.t('用户名'),
                        searchDefaultValue: ''
                    },
                    {
                        key: 'realNameLike',
                        title: this.$i18n.t('姓名'),
                        searchDefaultValue: ''
                    },
                    {
                        key: 'mobileLike',
                        title: this.$i18n.t('电话'),
                        searchDefaultValue: ''
                    },
                    {
                        key: 'emailLike',
                        title: this.$i18n.t('邮箱'),
                        searchDefaultValue: ''
                    }
                ],
                columns: [
                    {
                        title: this.$i18n.t('用户名'),
                        key: 'account',
                        columnShow: true,
                        sortable: false,
                        resizable: true,
                        width: 130,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        render: (h, params) => h('incognito', { props: { sensitiveData: params.row.account, type: 'name' } }, params.row.account)
                    },
                    {
                        title: this.$i18n.t('姓名'),
                        key: 'realName',
                        columnShow: true,
                        sortable: false,
                        resizable: true,
                        width: 130,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        render: (h, params) => h('incognito', { props: { sensitiveData: params.row.realName, type: 'name' } }, params.row.realName)
                    },
                    {
                        title: this.$i18n.t('邮箱'),
                        key: 'email',
                        columnShow: true,
                        sortable: false,
                        resizable: true,
                        width: 130,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        render: (h, params) => h('incognito', { props: { sensitiveData: params.row.email } }, params.row.email)
                    },
                    {
                        title: this.$i18n.t('电话'),
                        key: 'mobile',
                        columnShow: true,
                        sortable: false,
                        resizable: true,
                        width: 130,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        render: (h, params) => h('incognito', { props: { sensitiveData: params.row.mobile } }, params.row.mobile)
                    },
                    {
                        title: this.$i18n.t('创建时间'),
                        key: 'createdDt',
                        width: 150,
                        columnShow: true,
                        sortable: true,
                        resizable: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis'
                    },
                    {
                        title: this.$i18n.t('状态'),
                        key: 'status',
                        disabledSearch: true,
                        resizable: true,
                        minWidth: 130,
                        className: 'ellipsis',
                        render: (h, params) => {
                            return h('statusview', {
                                props: {
                                    state: params.row.status,
                                    stateName: this.statusList[params.row.status]
                                }
                            })
                        }
                    },
                    {
                        title: this.$i18n.t('操作'),
                        width: 100,
                        columnShow: true,
                        sortable: false,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        fixed: 'right',
                        render: (h, params) => {
                            return h('div', {
                                class: 'tbl-btn-div'
                            }, [
                                h('a', {
                                    class: { 'disabled-per': !this.hasPermission('CH0406') },
                                    on: { click: () => this.hasPermission('CH0406') && this.delete(params.row.userSid) }
                                }, this.$i18n.t('删除'))
                            ])
                        }
                    }
                ]
            }
        }
    },
    methods: {
        openModal (data) {
            this.show = true
            this.data = data
            if (this.data.orgSid) {
                this.tableAttr.source.url = this.urlFormat(API.GET_ACCESS_PROJECTS_ID_USERS, false, [this.data.orgSid])
            }
        },
        // 刷新列表
        refresh: function () {
            this.$refs.rcTable.refreshTable()
        },
        // 新增规格定价
        configClick () {
            this.$refs.configureusers.openModal(this.data)
        },
        // 删除
        delete (id) {
            this.$Modal.confirm({
                okText: this.$t('确定'),
                cancelText: this.$t('取消'),
                title: this.$t('删除'),
                content: this.$t('确定要删除该条配置用户信息吗?'),
                onOk: () => {
                    this.axios.put(this.urlFormat(API.PUT_ACCESS_PROJECTS_REMOVE, false), {
                        orgSid: this.data.orgSid,
                        userId: id
                    }).then(res => {
                        this.loading = false
                        this.refresh()
                    }).catch(e => {
                        this.loading = false
                    })
                }
            })
        }
    }
}
</script>
